import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/common";
import AppShell from "@/components/AppShell";
import Marketing from "@/pages/Marketing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Overview from "@/pages/Overview";
import SpiderContact from "@/pages/SpiderContact";
import Entities from "@/pages/Entities";
import EntityDetail from "@/pages/EntityDetail";
import Groups from "@/pages/Groups";
import Research from "@/pages/Research";
import Actions from "@/pages/Actions";
import ReviewQueue from "@/pages/ReviewQueue";
import ImportExport from "@/pages/ImportExport";
import Settings from "@/pages/Settings";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading full label="VERIFYING SESSION" />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function Public({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading full label="LOADING" />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Marketing />} />
            <Route path="/login" element={<Public><Login /></Public>} />
            <Route path="/register" element={<Public><Register /></Public>} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Overview />} />
              <Route path="spider-contact" element={<SpiderContact />} />
              <Route path="entities" element={<Entities />} />
              <Route path="entities/:id" element={<EntityDetail />} />
              <Route path="groups" element={<Groups />} />
              <Route path="research" element={<Research />} />
              <Route path="actions" element={<Actions />} />
              <Route path="review" element={<ReviewQueue />} />
              <Route path="data" element={<ImportExport />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="bottom-right" theme="dark" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
